// extracted by mini-css-extract-plugin
export default {"container":"Controls_container__RakqW","containerPaused":"Controls_containerPaused__naWzy"};